import React, { useMemo } from "react";
import { Box, Tabs, Tab, IconButton, Typography } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

/**
 * Props:
 * - month: Date (cualquier día dentro del mes seleccionado)
 * - preset: "THIS_MONTH" | "LAST_MONTH" | "LAST_6_MONTHS" | "LAST_YEAR" | "CUSTOM"
 * - onChange: ({ preset, month }) => void
 */
export default function ExpensesDateFilterBar({ month, preset, onChange }) {
  const monthLabel = useMemo(() => {
    const y = month.getFullYear();
    const m = String(month.getMonth() + 1).padStart(2, "0");
    return `${y}-${m}`;
  }, [month]);

  const moveMonth = (delta) => {
    const next = new Date(month);
    next.setMonth(next.getMonth() + delta);
    onChange({ preset: "THIS_MONTH", month: next }); // al mover mes, cae en "Este mes"
  };

  const handlePreset = (_, nextPreset) => {
    if (!nextPreset) return;
    onChange({ preset: nextPreset, month }); // month se mantiene (sirve para THIS/LAST)
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
      {/* Selector de mes */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          border: "1px solid",
          borderColor: "divider",
          borderRadius: 1,
          px: 1,
          py: 0.5,
          minWidth: 140,
          justifyContent: "space-between",
        }}
      >
        <IconButton size="small" onClick={() => moveMonth(-1)}>
          <ChevronLeftIcon fontSize="small" />
        </IconButton>

        <Typography variant="body2" sx={{ fontWeight: 600 }}>
          {monthLabel}
        </Typography>

        <IconButton size="small" onClick={() => moveMonth(1)}>
          <ChevronRightIcon fontSize="small" />
        </IconButton>
      </Box>

      {/* Tabs */}
      <Tabs
        value={preset}
        onChange={handlePreset}
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          minHeight: 40,
          "& .MuiTab-root": { minHeight: 40 },
        }}
      >
        <Tab value="THIS_MONTH" label="ESTE MES" />
        <Tab value="LAST_MONTH" label="EL MES PASADO" />
        <Tab value="LAST_6_MONTHS" label="ÚLTIMOS 6 MESES" />
        <Tab value="LAST_YEAR" label="ÚLTIMO AÑO" />
        <Tab value="CUSTOM" label="PERSONALIZADO" />
      </Tabs>
    </Box>
  );
}
